const breakpoints = {
  smallPhone: 360,
  phone: 550,
};

export default breakpoints;
